import { ITeamLeadPermissionsJson } from '@scale/shared/types/expertManagement';
import { useMutation } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

export const useDeleteTeamLeadPermissions = () => {
  return useMutation((workerId: string) =>
    apiFetch<ITeamLeadPermissionsJson>(null, 'internal/expert-management/permissions', {
      method: 'DELETE',
      body: { worker: workerId },
    }),
  );
};
